import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ParkProfileState {
    selectedView: string;
}

const initialState: ParkProfileState = {
    selectedView: 'wind-turbines',
};

const parkProfileSlice = createSlice({
    name: 'parkProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = parkProfileSlice.actions;
export default parkProfileSlice.reducer;